import { getUniqueId } from "@jugl-web/utils";
import { RtkEmptySplitApi } from "../../types";
import { AISubtaskSuggestion } from "./types";

export const addAIAssistantApi = (emptySplitApi: RtkEmptySplitApi) => {
  const apiWithTags = emptySplitApi.enhanceEndpoints({
    addTagTypes: [],
  });

  const aiAssistantApi = apiWithTags.injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getTaskSummary: builder.query<
        string,
        {
          entityId: string;
          taskId: string;
          boardId: string;
        }
      >({
        query: ({ entityId, taskId, boardId }) => ({
          url: `/ai/${entityId}/invoke`,
          method: "POST",
          silentError: true,
          data: {
            func: "task_summary",
            board_id: boardId,
            task_id: taskId,
            query: "breif me about this task",
          },
        }),
      }),
      getNotificationSummary: builder.query<
        string,
        {
          entityId: string;
          boardId?: string;
        }
      >({
        query: ({ entityId, boardId }) => ({
          url: `/ai/${entityId}/invoke`,
          method: "POST",
          silentError: true,
          data: {
            func: "notification_summary",
            board_id: boardId,
          },
        }),
      }),
      getUserPerformance: builder.query<
        string,
        {
          entityId: string;
          userId: string;
        }
      >({
        query: ({ entityId, userId }) => ({
          url: `/ai/${entityId}/invoke`,
          method: "POST",
          silentError: true,
          data: {
            func: "emp_performance",
            user_id: userId,
            board_id: "",
            query: "",
          },
        }),
      }),
      getAISubtasksSuggestion: builder.query<
        AISubtaskSuggestion[],
        {
          entityId: string;
          taskId: string;
        }
      >({
        query: ({ entityId, taskId }) => ({
          url: `/ai/${entityId}/invoke`,
          method: "POST",
          silentError: true,
          data: {
            func: "suggest_subtasks",
            task_id: taskId,
          },
        }),
        transformResponse: (response: { subtasks: string[] }) =>
          response.subtasks.map((item) => ({
            id: getUniqueId(),
            suggestion: item,
          })),
      }),
    }),
  });

  return aiAssistantApi;
};

export type AIAssistantApi = ReturnType<typeof addAIAssistantApi>;
